import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import DialogModal from "./DialogModal";
import Typography from "material-ui/Typography";

const styles = () => ({
  paper: {
    maxHeight: "unset",
    background: "#F4F6F9",
    width: "600px",
  },

  contentContainer: {
    padding: 0,
    margin: 0,
    minWidth: "600px",
  },

  desc: {
    color: "#181819",
    fontSize: "13px",
  },

  container: {
    background: "#F4F6F9",
    border: "1px solid #D8DBDF",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    textAlign: "left",
  },

  contact: {
    background: "#FFFFFF",
    width: "100%",
    boxSizing: "border-box",
    padding: "20px",
    marginTop: "30px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },
});

class PromotePlanChangeDialog extends React.Component {
  render() {
    const { classes, toggleDialog, isOpen, type } = this.props;

    return (
      <DialogModal
        title={type.title}
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          paper: classes.paper,
          contentContainer: classes.contentContainer,
        }}
      >
        <div className={classes.container}>
          <div className={classes.desc}>{type.desc ? type.desc : "この機能をご利用いただくには、オプションの変更が必要です。右下のチャットフォームまたは下記いずれかの方法より、ご連絡ください。ご質問のみでもけっこうでございます。ご連絡お待ちしております。"}</div>
          <div className={classes.contact}>
          <Typography variant="body2">
              {"担当者から話を聞きたい: "}
              <a className={classes.link} href={process.env.REACT_APP_SPIR_LINK_SOURCE_OTHER} target="_blank" rel="noopener noreferrer">
                オンラインMTG予約のリンク
              </a>
            </Typography>
            <Typography variant="body2">
              {"メールによるお問い合わせ: "}
              <a className={classes.link} href="mailto:cs@keymanletter.com" target="_blank" rel="noopener noreferrer">
                cs@keymanletter.com
              </a>
            </Typography>
          </div>
        </div>
      </DialogModal>
    );
  }
}

PromotePlanChangeDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  type: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
};

PromotePlanChangeDialog.defaultProps = {};

export default withStyles(styles)(PromotePlanChangeDialog);



// WEBPACK FOOTER //
// ./src/components/common/PromotePlanChangeDialog.jsx